export default __webpack_public_path__ + "static/media/mountain-1.f5f982a6.png";